<template>
  <div>
    <template>
      <div id="payment-container">
        <card-component ref="cardInfo" :edit-model="editModel" @setPaymentMethod="$emit('setPaymentMethod', 1)" :selected-payment-method="selectedPaymentMethod"
        />
        <div v-if="user" class="form-row mb-3">
          <div class="custom-control custom-radio col-md-8 mt-2 ml-1">
            <input
              id="saveCardInput"
              type="checkbox"
              name="customCheckbox"
              class="custom-control-input"
              @input="(val) => $emit('save-credit', val.target.checked)"
            />
            <label class="custom-control-label" :class="showNewUi && 'pt-1'"  for="saveCardInput">{{
              $t("message.saveCardForNextTime")
            }}</label>
          </div>
        </div>
      </div>
    </template>
    <template v-if="this.savedCards.length">
      <div >
        <div class="pl-3 border border-2 border-dark d-flex flex-row" style="border-radius: 1rem">
          <div @click="$emit('setPaymentMethod', 20)" class="new-custom-checkbox mt-4 mr-2" :class="selectedPaymentMethod === 20 && 'bg-black'"></div>
          <vselect
            :options="this.savedCards"
            :searchable="false"
            :clearable="false"
            v-model="selectedCard"
            label="Standard"
            class="w-100 new-selected-card"
          >
            <template slot="option" slot-scope="option" class="p-5" >
              <div v-if="option.ElidedPan" class="payment-card py-2 mr-4">
                <span
                    v-if="showNewUi"
                  :style="{ 'background-image': absoluteUrl(option.CardType) }"
                  :class="option.CardType | cardName"
                  >{{ option.ElidedPan | newFormatCard }}</span
                >

                <span
                    v-else
                  :style="{ 'background-image': absoluteUrl(option.CardType) }"
                  :class="option.CardType | cardName"
                  >{{ option.ElidedPan | formatCard }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option" >

              <span
                v-if="option.ElidedPan"
                :class="[option.CardType]"
                style="float:left;margin-right:10px"
                :style="showNewUi && 'margin-left: -0.6rem'"
                class="material-icons"
                >credit_card</span
              >

              <span v-if="showNewUi">           {{ option.ElidedPan | newFormatCard }}</span>
              <span v-else>           {{ option.ElidedPan | formatCard }}</span>

            </template>
          </vselect>
        </div>
      </div>
    </template>
  </div>
</template>
<style>
.cardImg{
  width: 27px;
  height: 20px;
  margin-right: 4px;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import { $$ } from "./../../../../sharedscripts/OO_jquery";
import vselect from "vue-select";
import { wcconfig } from "../../../../../wcConfig.js";
import CardComponent from "../../../shared/CardComponent";
import { getCards } from '../../../../api/payment/DefaultPaymentHandler';
function removeNoise(value) {
  let index = value.indexOf("card");
  if (index === -1) {
    return value;
  } else {
    return value.substring(0, index);
  }
}
export default {
  components: {
    vselect,
    CardComponent,
  },
  filters: {
    cardName: removeNoise,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    dbuser: {
      type: Object,
      default: () => {},
    },
    editModel: {
      type: Object,
      default: () => {},
    },
    canPayByOtherThanCard: {
      type: Boolean,
      default: false,
    },
    selectedPaymentMethod : {
        type : Number,
        default:  null
    },
    customerID: {
      type: String,
      default: "",
    },
    storeID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedCard: {},
      savedCards: [],
    };
  },
  async mounted() {
    if (
      window.location.protocol == "http:" &&
      window.location.hostname != "localhost"
    ) {
      $$("#payment-container:input").attr("disabled", true);
    }
    if (this.customerID) {
      const response = await getCards(this.customerID, this.storeID);
      if (!response.error) {
        response.cards.forEach((card) => {
          this.savedCards.push({
            CardIdentifier: card.id,
            ElidedPan: `XXXXXXXXXXXX${card.card.last4}`,
            CardType: card.card.brand
          });
        });
      }
    }
    if (
      this.dbuser &&
      this.savedCards.length
    ) {
      this.selectedCard = this.savedCards[0];
    }
  },
  watch: {
    dbuser() {
      if (
        this.dbuser &&
        this.savedCards.length
      ) {
        this.selectedCard = this.savedCards[0];
      }
    },
    selectedCard(newValue) {
      this.editModel.SelectedCard = newValue;
      this.setCardNumber(newValue);
    },
  },

  methods: {
    ...mapActions(["setCardNumber"]),
    validate() {
      return this.$validator.validateAll();
    },
    cardInfoValidate() {
      if (this.$refs.cardInfo) return this.$refs.cardInfo.validate();
      else return null;
    },
    absoluteUrl(cardType) {
      if (!this.isWC()) return "";
      let card = removeNoise(cardType);
      switch (card) {
        case "master":
          return "url(" + wcconfig.assets.master + ") !important";
        case "visa":
          return "url(" + wcconfig.assets.visa + ") !important";
        default:
          return "";
      }
    },
  },

  computed : {
    ...mapGetters(["viewConfig"]),
    showNewUi(){
      return this.viewConfig.IsNewUi;
    },
    getSelectedPaymentMethod: {
      get() {
        return this.selectedPaymentMethod;
      },
      set(val) {
        this.$emit("setPaymentMethod", val || 1);
      },
    },
  }
};
</script>
